import React from 'react';
import _ from 'lodash';

import CardLaUnidadEquipo from '../CardLaUnidadEquipo/index';

import './css/styles.css';

class LaUnidadEquipo extends React.Component{

    
    constructor(props){
        super(props);
        this.state = {
            equipo: [],
        }
    }

    componentWillMount(){
        fetch('/api/uip/equipo', {
            method: 'GET',
            headers:{
              'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => this.setState({ equipo: response }))
            .catch(err => console.log(err))
    }

    render(){

        let items = 1;
        const objEquipo = [];
        const objetosEquipo = _.map(this.state.equipo, (data, i) => {
            if(items === 1){
                objEquipo[0] = 
                    <div className={`col s12 m6`}>
                        <div className={`row`}>
                            <div className={`col s12 m1`}></div>
                            <div className={`col s12 m10`}>
                                <CardLaUnidadEquipo 
                                    nombre={data.nombre}
                                    funcion={data.funcion}
                                    imagen={data.imagen}
                                    key={i}/>
                            </div>
                            <div className={`col s12 m1`}></div>
                        </div>
                    </div>;

                items = items + 1;

                if(this.state.equipo.length==(i+1)){
                    return(
                        <div className="row">
                            {objEquipo[0]}
                        </div>
                    )
                }
            }
            else {
                objEquipo[1] = 
                    <div className={`col s12 m6`}>
                        <div className={`row`}>
                            <div className={`col s12 m1`}></div>
                            <div className={`col s12 m10`}>
                                <CardLaUnidadEquipo 
                                    nombre={data.nombre}
                                    funcion={data.funcion}
                                    imagen={data.imagen}
                                    key={i}/>
                            </div>
                            <div className={`col s12 m1`}></div>
                        </div>
                    </div>;

                    items = 1;

                    return(
                        <div className="row">
                            {objEquipo[0]}
                            {objEquipo[1]}
                        </div>
                    )
            }
        })

        return(
            <section className="container padding-top">
                {objetosEquipo}
            </section>
        );
    }
}

export default LaUnidadEquipo;